var map = {
	"./grade-1.png": "46c1",
	"./grade-2.png": "b5cf",
	"./grade-3.png": "55d8",
	"./grade-4-1.png": "c3fd",
	"./grade-4.png": "22f1",
	"./grade-5.png": "2c7c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4a00";